/**
 * ProgressBar Component
 * Visual progress indicator for survey completion
 */

import React from 'react';

/**
 * Progress visualization component
 * @param {Object} props
 * @param {Object} props.progress - Progress data from API
 * @param {number} props.progress.base_completed - Number of base questions completed
 * @param {number} props.progress.total_base - Total number of base questions (15)
 * @param {number} props.progress.followups_used - Number of follow-up questions asked
 * @param {number} props.progress.followups_remaining - Remaining follow-up budget
 * @param {number} props.progress.percent_complete - Overall completion percentage
 */
function ProgressBar({ progress }) {
    if (!progress) return null;

    const {
        base_completed,
        total_base,
        followups_used,
        followups_remaining,
        percent_complete,
    } = progress;

    return (
        <div className="progress-bar-container">
            {/* Main progress bar */}
            <div className="progress-bar-wrapper">
                <div className="progress-bar">
                    <div 
                        className="progress-bar-fill"
                        style={{ width: `${percent_complete}%` }}
                    >
                        <span className="progress-bar-text">
                            {Math.round(percent_complete)}%
                        </span>
                    </div>
                </div>
            </div>

            {/* Progress details */}
            <div className="progress-details">
                <div className="progress-item questions">
                    <span className="progress-icon">📋</span>
                    <span className="progress-label">Questions:</span>
                    <span className="progress-value">
                        {base_completed} / {total_base}
                    </span>
                </div>
                
                <div className="progress-item followups">
                    <span className="progress-icon">💬</span>
                    <span className="progress-label">Follow-ups:</span>
                    <span className="progress-value">
                        {followups_used} used
                        {followups_remaining > 0 && (
                            <span className="remaining">
                                ({followups_remaining} may remain)
                            </span>
                        )}
                    </span>
                </div>
            </div>
        </div>
    );
}

export default ProgressBar;
